import { render, staticRenderFns } from "./MessageTags.vue?vue&type=template&id=6b94cb84&"
import script from "./MessageTags.vue?vue&type=script&lang=js&"
export * from "./MessageTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports